interface Props {
  values: number[];
  color?: string;
  height?: number;
  width?: number;
}

export function Sparkline({ values, color = 'var(--accent)', height = 32, width = 120 }: Props) {
  if (values.length === 0) return null;
  const max = Math.max(1, ...values);
  const stepX = width / Math.max(1, values.length - 1);
  const points = values
    .map((v, i) => `${i * stepX},${height - (v / max) * height}`)
    .join(' ');
  const last = values[values.length - 1] ?? 0;
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <defs>
        <linearGradient id="spark-fill" x1="0" x2="0" y1="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.35" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <polyline
        points={`0,${height} ${points} ${width},${height}`}
        fill="url(#spark-fill)"
        stroke="none"
      />
      <polyline
        points={points}
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <circle cx={(values.length - 1) * stepX} cy={height - (last / max) * height} r={2.5} fill={color} />
    </svg>
  );
}
